import gsap, { Power3 } from 'gsap';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from "../_app/cuchillo/core/Element";
import { ScrollItem__Default } from './ScrollItem__Default';

class ScrollItem__HighlightText extends ScrollItem__Default {
    _texts;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setUpAnimation();
    }

    setUpAnimation() {
        const texts = GetBy.selector('.__text *', this.item);
        this._texts = new SplitText(texts, { type: 'words', tag: 'span' }).words;
        gsap.set(this._texts, { opacity: 0 });
        this._texts.map(texts => {
            texts.classList.add('--text-anim');
            texts.classList.add('--lime');
            gsap.set(texts, { opacity: 0 });
        });
    }

    showAnimation() {
        super.showAnimation();
        this._texts.map((texts, i) => {
            const delay = .08 * i;
            gsap.to(texts, { opacity: 1, duration: .3, delay, ease: Power3.easeInOut });
            gsap.delayedCall(delay + .1, () => { texts.classList.remove('--lime') });
        })
    }
}

Scroll._registerClass('HighlightText', ScrollItem__HighlightText);
